<template>
    <div
        class="article-list"
        id="main-container"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
    >
        <el-container>
            <el-aside>
                <bread-crumb></bread-crumb>
                <nav-menu :list="listNav" @menuChange="selectMenu"></nav-menu>
                <article-rec></article-rec>
                <ListAdv :ListAdv="ListAdv"></ListAdv>
            </el-aside>
            <el-main>
                <p class="total-p">相关结果{{total}}条</p>
                <div v-for="single in articleList" :key="single.id" v-show="articleList.length > 0">
                    <single-article :single="single" @detail="todetail"></single-article>
                </div>

                <el-pagination
                    background
                    layout="jumper, prev, pager, next, slot, total"
                    :total="total"
                    :current-page="page"
                    @current-change="currentChange"
                    @prev-click="prevClick"
                    @next-click="nextClick"
                ></el-pagination>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import BreadCrumb from '../../components/common/BreadCrumb.vue';
    import ArticleRec from '../../components/common/ArticleRec';
    import SingleArticle from '../../components/common/SingleArticle';
    import NavMenu from '../../components/content/nav-menu';
    import ListAdv from '../../components/common/ListAdv';

    export default {
        data() {
            return {
                total: 0,
                listNav: [],
                articleList: [],
                loading: true,
                page: 1,
                class_id: this.$route.query.id,
                ListAdv: []
            };
        },
        components: {
            BreadCrumb,
            ArticleRec,
            SingleArticle,
            NavMenu,
            ListAdv
        },
        computed: {},
        created() {
            window.scrollTo(0, 0);
            this.getArticleList();
            this.getNaListvById();
            this.getAdvertise();
        },
        methods: {
            getAdvertise() {
                this.httpGet(this.$root.getAdvList)
                    .then(res => {
                        this.ListAdv = res.DetailList.slice(0, 2);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('ListAdv-err', err);
                    });
            },
            getArticleList() {
                this.loading = true;
                window.scrollTo(0, 0);
                this.httpGet(this.$root.getArticleList, {
                    class_id: this.class_id,
                    page: this.page
                })
                    .then(result => {
                        if (result.count) {
                            this.articleList.push(...result.list);
                            this.total = Number(result.count);
                        } else {
                            this.articleList = [];
                            this.total = 0;
                        }
                        this.$nextTick(() => {
                            this.loading = false;
                        });
                    })
                    .catch(err => {
                        console.error('getArticleList-err', err);
                    });
            },
            getNaListvById() {
                this.httpGet(this.$root.getNaListvById, {
                    id: this.$route.query.id
                })
                    .then(result => {
                        this.listNav.push(...result);
                    })
                    .catch(err => {
                        console.error('getNaListvById-err', err);
                    });
            },

            selectMenu(nav) {
                console.log('navvv', nav);
                this.class_id = nav;
                this.page = 1;
                this.articleList = [];
                this.getArticleList();
            },
            todetail(single) {
                let id = this.class_id;
                let that = this;
                this.listNav.filter(function(item) {
                    if (item.id == id) {
                        console.log('item--', item);
                        let breadObj = {
                            name: item.mname,
                            path: 'article-list?id=' + item.id
                        };
                        that.$store.commit('setBreadArr', breadObj);
                    } else {
                        if (item.children.length) {
                            item.children.filter(function(child) {
                                if (id == child.id) {
                                    console.log('child--', child);
                                    let arr = [
                                        {
                                            name: item.mname,
                                            path: 'article-list?id=' + item.id
                                        },
                                        {
                                            name: child.mname,
                                            path: 'article-list?id=' + child.id
                                        }
                                    ];
                                    that.$store.commit('setBreadArr', arr);
                                }
                            });
                        }
                    }
                });
                this.$router.push({
                    name: 'article-details',
                    query: {
                        id: single.id
                    }
                });
            },

            currentChange(page) {
                console.log('currentChange', page);
                this.page = page;
                this.articleList = [];
                this.getArticleList();
            },
            prevClick(page) {
                console.log('currentChange1', page);
                this.page = page;
                this.articleList = [];
                this.getArticleList();
            },
            nextClick(page) {
                console.log('currentChange2', page);
                this.page = page;
                this.articleList = [];
                this.getArticleList();
            }
        },
        watch: {
            '$route.query.id': function(newValue, oldValue) {
                console.log('newValue, oldValue', newValue, oldValue);
                // if (!this.loading && this.$route.name === 'article-list') {
                this.class_id = newValue;
                this.articleList = [];
                this.page = 1;
                this.total = 0;
                this.listNav = [];
                this.getArticleList();
                this.getNaListvById();
                // }
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .el-aside {
        // margin-top: 20px;
    }

    .el-main {
        padding-top: 0;
        padding-left: 18px;
    }

    .article-list {
        font-family: 'SimSun';
    }

    .total-p {
        height: 22px;
        padding: 13px 0;
        color: #197DFF;
    }

    .single-list :hover {
        cursor: pointer;
    }

    .more {
        more();
    }

    >>>.el-pagination {
        width: 840px;
        flex-center();
        padding: 20px;
        background: white;
    }
</style>
